var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$breakpoint.smAndDown)?_c('v-btn',{staticClass:"sticky",attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.$emit('showOffers')}}},[_vm._v("\n    "+_vm._s(_vm.$t('view_offers'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }